<template>
  <div class="content">
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 text-white d-inline-block mb-0">
            {{ $t("wms.menu.inventory") }}
          </h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>

        <div class="col-lg-6 col-5 text-right">
          <base-button
            size="md"
            type="neutral"
            @click="handleInventoryTransfer()"
            >{{ $t("inventory_transfer") }}</base-button
          >
          <base-button size="md" type="neutral" @click="handleInventoryOut()">{{
            $t("inventory_out")
          }}</base-button>
          <base-button size="md" type="neutral" @click="handleInventoryIn()">{{
            $t("inventory_in")
          }}</base-button>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--6">
      <div>
        <card
          class="no-border-card"
          body-classes="px-0 pb-1"
          footer-classes="pb-2"
        >
          <template slot="header">
            <div class="row">

              <div class="col-md-2">
                <base-input>
                  <flat-picker
                    slot-scope="{ focus, blur }"
                    @on-open="focus"
                    @on-close="blur"
                    :config="{ allowInput: true, enableTime: true,dateFormat: 'Y-m-d H:i',time_24hr: true }"
                    class="form-control datepicker"
                    v-model="startDate"
                  >
                  </flat-picker>
                </base-input>
              </div>

              <div class="col-md-2">
                <base-input>
                  <flat-picker
                    slot-scope="{ focus, blur }"
                    @on-open="focus"
                    @on-close="blur"
                    :config="{ allowInput: true ,enableTime: true,dateFormat: 'Y-m-d H:i',time_24hr: true }"
                    class="form-control datepicker"
                    v-model="endDate"
                  >
                  </flat-picker>
                </base-input>
              </div>

              <div class="col-md-3">
                <base-input>
                  <el-select
                    v-model="StorageID"
                    :placeholder="$t('wms.storage')"
                  >
                    <el-option
                      v-for="option in Storage"
                      :key="option.ID"
                      :label="option.Name"
                      :value="option.ID"
                    >
                    </el-option>
                  </el-select>
                </base-input>
              </div>
              <div class="col-md-2">
                <base-button size="md" type="neutral" @click="ListInventory()">
                  Search
                </base-button>
                <base-button
                  size="md"
                  type="neutral"
                  @click="InventoryExport()"
                >
                  Export
                </base-button>
              </div>
            </div>
          </template>
          <div>
            <div class=" col-12 d-flex justify-content-center justify-content-sm-between flex-wrap " >
           

              <div>
                <base-input
                  v-model="SearchKeyword"
                  prepend-icon="fas fa-search"
                  :placeholder="$t('search')"
                >
                </base-input>
				<!-- add checkbox -->
				<base-checkbox v-model="showActive">Show Active</base-checkbox>
              </div>
            </div>
            <el-table
              :data="queriedData"
              row-key="id"
              header-row-class-name="thead-light"
              @sort-change="sortChange"
              @selection-change="selectionChange"
            >
              <el-table-column :label="$t('product')">
				<div slot-scope="{$index, row }" class="d-flex">
					{{ row.ProductName }}
				</div>
			  </el-table-column>

			  <el-table-column label="ยอดคงเหลือ">
				<div slot-scope="{$index, row }" class="d-flex">
					{{GetItemBalance(row) }}
				</div>
			  </el-table-column>

			  <el-table-column label="ยอดคงเหลือก่อนหน้า">
				<div slot-scope="{$index, row }" class="d-flex">
					{{GetItemBalanceStamp(row) }}
				</div>
			  </el-table-column>


			  <el-table-column label="เข้า">
				<div slot-scope="{$index, row }" class="d-flex">
					{{GetItemIn(row) }}
				</div>
			  </el-table-column>

			  <el-table-column label="ออก">
				<div slot-scope="{$index, row }" class="d-flex">
					{{ GetItemOut(row) }}
				</div>
			  </el-table-column>

			  <el-table-column label="แพ็ค">
				<div slot-scope="{$index, row }" class="d-flex">
					{{ GetItemOutByOrder(row) }}
				</div>
			  </el-table-column>

              <el-table-column
                min-width="200px"
                align="right"
                :label="$t('actions')"
              >
                <div slot-scope="{ $index, row }" class="d-flex">
                  <!-- <base-button
                    @click.native="handleIn($index, row)"
                    class="edit"
                    type="warning"
                    size="sm"
                    icon
                    v-if="row.StorageID == 1"
                  >
                    <i class="text-dtac-bt fa fa-edit"></i>
                    {{ $t("wms.inventory_in") }}
                  </base-button>

                  <base-button
                    @click.native="handleOut($index, row)"
                    class="edit"
                    type="warning"
                    size="sm"
                    icon
                    v-if="row.StorageID == 1"
                  >
                    <i class="text-dtac-bt fa fa-edit"></i>
                    {{ $t("wms.inventory_out") }}
                  </base-button> -->
                  <base-button
                    @click.native="handleDelete($index, row)"
                    class="remove btn-link"
                    type="danger"
                    size="sm"
                    icon
                  >
                    <i class="text-dtac-bt fa fa-trash text-white"></i>
                  </base-button>
                </div>
              </el-table-column>
            </el-table>
          </div>
          <div
            slot="footer"
            class="
              col-12
              d-flex
              justify-content-center justify-content-sm-between
              flex-wrap
            "
			v-if="queriedData.length != 0"
          >
            <div class="">
              <p class="card-category">
                {{ $t("data") }} {{ from + 1 }} {{ $t("to") }} {{ to }}
                {{ $t("of") }}
                {{ total }}
                <span v-if="selectedRows.length">
                  - &nbsp; &nbsp; {{ selectedRows.length }}
                  {{ $t("row_select") }}
                </span>
              </p>
            </div>
            <base-pagination
              class="pagination-no-border"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
            >
            </base-pagination>
          </div>
        </card>
      </div>
    </div>

    <modal :show.sync="showAddModal" modal-classes="modal-secondary">
      <form class="new-event--form" @submit.prevent="saveEvent">
        <base-input
          :label="$t('wms.product')"
          input-classes="form-control-alternative new-event--title"
        >
          <el-select v-model="md.ProductID" :placeholder="$t('wms.product')">
            <el-option
              v-for="option in Product"
              :key="option.ID"
              :label="option.Name"
              :value="option.ID"
            >
            </el-option>
          </el-select>
        </base-input>

        <base-input
          :label="$t('wms.storage')"
          input-classes="form-control-alternative new-event--title"
        >
          <el-select v-model="md.StorageID" :placeholder="$t('wms.storage')">
            <el-option
              v-for="option in Storage"
              :key="option.ID"
              :label="option.Name"
              :value="option.ID"
            >
            </el-option>
          </el-select>
        </base-input>

        <base-input
          v-model="md.Quantity"
          :label="$t('wms.amount')"
          input-classes="form-control-alternative new-event--title"
        >
        </base-input>

        <base-input
          v-model="md.Cost"
          :label="$t('wms.cost')"
          input-classes="form-control-alternative new-event--title"
        >
        </base-input>

        <base-input
          v-model="md.Note"
          :label="$t('wms.note')"
          input-classes="form-control-alternative new-event--title"
        >
        </base-input>

        <input type="hidden" class="new-event--start" />
        <input type="hidden" class="new-event--end" />
      </form>

      <template slot="footer">
        <button
          type="submit"
          class="btn btn-md btn-primary"
          @click="handleUpdate()"
        >
          {{ $t("save") }}
        </button>
        <button
          type="button"
          class="btn btn-md btn-link ml-auto"
          @click="showAddModal = false"
        >
          {{ $t("close") }}
        </button>
      </template>
    </modal>

    <modal :show.sync="showInOutModal" modal-classes="modal-secondary">
      <form class="new-event--form" @submit.prevent="saveEvent">
        <base-input
          v-model="inOut.Quantity"
          :label="$t('wms.amount')"
          input-classes="form-control-alternative new-event--title"
        >
        </base-input>

        <base-input
          v-model="inOut.Cost"
          :label="$t('wms.cost')"
          input-classes="form-control-alternative new-event--title"
        >
        </base-input>

        <base-input
          v-model="inOut.Note"
          :label="$t('wms.note')"
          input-classes="form-control-alternative new-event--title"
        >
        </base-input>

        <input type="hidden" class="new-event--start" />
        <input type="hidden" class="new-event--end" />
      </form>

      <template slot="footer">
        <button
          type="submit"
          class="btn btn-md btn-primary"
          @click="handleUpdateInOut()"
        >
          {{ $t("save") }}
        </button>
        <button
          type="button"
          class="btn btn-md btn-link ml-auto"
          @click="showInOutModal = false"
        >
          {{ $t("close") }}
        </button>
      </template>
    </modal>
  </div>
</template>
<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import { BasePagination } from "@/components";
import clientPaginationMixin from "./PaginatedTables/clientPaginationMixin";
import swal from "sweetalert2";
import { mapGetters, mapActions } from "vuex";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import moment from 'moment'

export default {
  mixins: [clientPaginationMixin],
  components: {
    flatPicker,
    BasePagination,
    RouteBreadCrumb,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },
  computed: {
    ...mapGetters({
      tableDataOrg: "WmsInventory/getSummaryByStorage",
      Product: "WmsProduct/getData",
      Storage: "WmsStorage/getData",
    }),
	
    tableData: function () {

		let result = [];
			if (this.Product.length == 0 || this.Storage.length == 0) {
				return result
			}

			this.Product.forEach((p,index) => {
				result[index] = { ProductID: p.ID, ProductName: p.Name };
				result[index][0] = {
					Balance: 0,
					BalanceStamp:0,
					ItemIn: 0,
					ItemOut: 0,
					ItemOutByOrder: 0,
					InventoryID: 0,
				};
				this.Storage.forEach(s => {
					result[index][s.ID] = {
						Balance: 0,
						BalanceStamp:0,
						ItemIn: 0,
						ItemOut: 0,
						ItemOutByOrder: 0,
						InventoryID: 0,
					};
				});
			});

            let fillData = result;

            // Fill Data
            this.tableDataOrg.forEach(v => {
                v.product.forEach(p => {
                    let index = fillData.findIndex((e)=>{
						return e.ProductID == p.product_id
					})

					if (index != -1){
						fillData[index][0].Balance += p.balance;
						fillData[index][0].BalanceStamp += p.balance_stamp;
						fillData[index][0].ItemIn += p.amount_in;
						fillData[index][0].ItemOut += p.amount_out;
						fillData[index][0].ItemOutByOrder += p.amount_packing;

						// find storage id
						let storageIndex = this.Storage.findIndex((e)=>{
							return e.ID == v.storage_id
						})

						if (storageIndex != -1) {
							fillData[index][v.storage_id].Balance = p.balance;
							fillData[index][v.storage_id].BalanceStamp = p.balance_stamp;
							fillData[index][v.storage_id].ItemIn = p.amount_in;
							fillData[index][v.storage_id].ItemOut = p.amount_out;
							fillData[index][ v.storage_id].ItemOutByOrder = p.amount_packing;
							fillData[index][ v.storage_id].InventoryID = p.inventory_id;
						} else {
							console.log("Not Found StorageID : " + v.storage_id)
						}
					}  else {
						console.log("Not Found ProductID : " + p.product_id)
					}
                });
            });

			//  fillter Storage ID
			


      if (this.SearchKeyword != "") {
        return fillData.filter((d) => {
			// check showActive for filter itemin , itemout , itemoutbyorder more than 0
			let filterActive = true;
			if (this.showActive) {
				filterActive = d[this.StorageID].ItemIn > 0 || d[this.StorageID].ItemOut > 0 || d[this.StorageID].ItemOutByOrder > 0
			}

          return (
			filterActive && (d.ProductName.toLowerCase().indexOf(this.SearchKeyword.toLowerCase()) != -1 )
          );
        });
      } else {
        return fillData.filter((d) => {

			let filterActive = true;
			if (this.showActive) {
				filterActive = d[this.StorageID].ItemIn > 0 || d[this.StorageID].ItemOut > 0 || d[this.StorageID].ItemOutByOrder > 0
			}

          return filterActive;
        });
      }
    },
    tableColumns: function () {
      return [
        {
          prop: "ProductName",
          label: this.$t("wms.product"),
          minWidth: 90,
          sortable: true,
        },

        {
          prop: "StorageName",
          label: this.$t("wms.storage"),
          minWidth: 100,
          sortable: true,
        },
        {
          prop: "Balance",
          label: this.$t("wms.balance"),
          minWidth: 120,
          sortable: true,
        },
        // {
        //   prop: "OverallAmount",
        //   label: this.$t("wms.overall_amount"),
        //   minWidth: 90,
        //   sortable: true,
        // },
        {
          prop: "ItemIn",
          label: "สินค้าเพิ่ม",
          minWidth: 90,
          sortable: true,
        },
        {
          prop: "ItemOut",
          label: "สินค้าเบิก",
          minWidth: 90,
          sortable: true,
        },
        {
          prop: "ItemOutByOrder",
          label: "สินค้าส่ง",
          minWidth: 90,
          sortable: true,
        },
      ];
    },
  },
  data() {
    return {
      propsToSearch: ["Number", "Email"],
      selectedRows: [],
      SearchKeyword: "",
	  showActive: false,
      showAddModal: false,
      showInOutModal: false,
      StorageID: 0,
      startDate: "",
      endDate: "",
      md: {
        InventoryID: 0,
        ProductID: "-",
        StorageID: "-",
        Note: "",
        Quantity: "0",
        Cost: 0,
      },
      inOut: {
        InventoryID: 0,
        ProductID: 0,
        StorageID: 0,
        Note: "",
        Quantity: 0,
        Cost: 0,
        Action: "",
      },
      rowEdit: {
        ID: 0,
        Number: "",
      },
    };
  },
  async mounted() {
	var today = moment().format('YYYY-MM-DD');
	this.startDate = today;
	this.endDate = moment(today).add(23,'hours').add(59,'minutes').format('YYYY-MM-DD HH:mm');

    await this.listProduct();
    await this.listStorage();
	if (this.Storage.length > 0 ) {
		this.StorageID = this.Storage[0].ID;
	}

    this.ListInventory();
  },
  methods: {
    ...mapActions({
      InventoryIn: "WmsInventory/InventoryIn",
      InventoryOut: "WmsInventory/InventoryOut",
      InventoryDelete: "WmsInventory/InventoryDelete",
      listData: "WmsInventory/listData",
      listProduct: "WmsProduct/listData",
      listStorage: "WmsStorage/listData",
	  listHistory: "WmsInventory/listHistoryStorage",
    }),

    ListInventory() {
    //   let params = {
    //     StartDate: moment(this.startDate).format('YYYY-MM-DD HH:mm') ,
    //     EndDate: moment(this.endDate).format('YYYY-MM-DD HH:mm') ,
    //   };
    //   console.log(params);

    //   this.listData(params);
	let params = {
				time_from: this.startDate,
                time_to: this.endDate,
                storage_id: 0,
                history_type: 0,
                order_id: 0,
                product_id: 0
            };
            this.listHistory(params);
    },

    InventoryExport() {
      const csvString = [
        ["สินค้า", "ตำแหน่งจัดเก็บสินค้า", "คงเหลือ", "สินค้าเพิ่ม", "สินค้าเบิก","สินค้าส่ง"],
        ...this.tableDataOrg.map((item) => [
          item.ProductName,
          item.StorageName,
          item.Balance,
          item.ItemIn,
          item.ItemOut,
          item.ItemOutByOrder,
        ]),
      ]
        .map((e) => e.join(","))
        .join("\n");

      let csvContent = "data:text/csv;charset=utf-8,\ufeff" + csvString;
      // var universalBOM = "\uFEFF";
      // var encodedUri = encodeURIComponent(universalBOM+csv);
      // window.open(encodedUri);

      var encodedUri = encodeURI(csvContent);
      var link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      link.setAttribute("download", "inventory.csv");
      document.body.appendChild(link); // Required for FF

      link.click();
    },

    handleInventoryTransfer() {
      this.$router.push({ name: "WmsInventoryTransfer" });
    },
    handleInventoryOut() {
      this.$router.push({ name: "WmsInventoryOut" });
    },
    handleInventoryIn() {
      this.$router.push({ name: "WmsInventoryIn" });
    },
    handleCreate() {
      // this.showAddModal = true;
      this.$refs.inv_in.showAddModal = true;
    },
    handleEdit(index, row) {
      this.showAddModal = true;
      this.rowEdit.ID = parseInt(row.ID);
      this.rowEdit.Number = parseInt(row.Number);
      this.md_charge_number = parseInt(row.ChargeType);
      this.md_email = row.Email;
    },
    handleIn(index, row) {
      this.showInOutModal = true;
      this.inOut.InventoryID = parseInt(row.ID);
      this.inOut.ProductID = 0;
      this.inOut.StorageID = 0;
      this.inOut.Action = "In";
    },
    handleOut(index, row) {
      this.showInOutModal = true;
      this.inOut.InventoryID = parseInt(row.ID);
      this.inOut.ProductID = 0;
      this.inOut.StorageID = 0;
      this.inOut.Action = "Out";
    },
    handleUpdate() {
      this.showAddModal = false;

      if (this.md.InventoryID == 0) {
        this.InventoryIn({
          PartnerID: 1,
          Note: this.md.Note,
          Detail: [
            {
              ReqIndex: 0,
              InventoryID: 0,
              ProductID: parseInt(this.md.ProductID),
              StorageID: parseInt(this.md.StorageID),
              Quantity: parseInt(this.md.Quantity),
              SumCost: parseFloat(this.md.Cost),
              Note: this.md.Note,
            },
          ],
        })
          .then((resp) => {
            this.listData();
            swal.fire({
              title: this.$t("edit_success"),
              text: ``,
              icon: "success",
              confirmButtonClass: "btn btn-success btn-fill",
              buttonsStyling: false,
            });
          })
          .catch((err) => {
            swal.fire({
              title: this.$t(err.response.data.Msg),
              text: this.getErrorText(err.response.data),
              icon: "error",
              confirmButtonClass: "btn btn-danger btn-fill",
              buttonsStyling: false,
            });
          });
      }
    },
    handleUpdateInOut() {
      this.showInOutModal = false;

      if (this.inOut.Action == "In") {
        this.InventoryIn({
          PartnerID: 1,
          Note: this.inOut.Note,
          Detail: [
            {
              ReqIndex: 0,
              InventoryID: parseInt(this.inOut.InventoryID),
              ProductID: 0,
              StorageID: 0,
              Quantity: parseInt(this.inOut.Quantity),
              SumCost: parseFloat(this.inOut.Cost),
              Note: this.inOut.Note,
            },
          ],
        })
          .then((resp) => {
            this.listData();
            swal.fire({
              title: this.$t("edit_success"),
              text: ``,
              icon: "success",
              confirmButtonClass: "btn btn-success btn-fill",
              buttonsStyling: false,
            });
          })
          .catch((err) => {
            swal.fire({
              title: this.$t(err.response.data.Msg),
              text: this.getErrorText(err.response.data),
              icon: "error",
              confirmButtonClass: "btn btn-danger btn-fill",
              buttonsStyling: false,
            });
          });
      } else {
        this.InventoryOut({
          PartnerID: 1,
          Note: this.inOut.Note,
          Detail: [
            {
              ReqIndex: 0,
              InventoryID: parseInt(this.inOut.InventoryID),
              ProductID: 0,
              StorageID: 0,
              Quantity: parseInt(this.inOut.Quantity),
              SumCost: parseFloat(this.inOut.Cost),
              Note: this.inOut.Note,
            },
          ],
        })
          .then((resp) => {
            this.listData();
            swal.fire({
              title: this.$t("edit_success"),
              text: ``,
              icon: "success",
              confirmButtonClass: "btn btn-success btn-fill",
              buttonsStyling: false,
            });
          })
          .catch((err) => {
            swal.fire({
              title: this.$t(err.response.data.Msg),
              text: this.getErrorText(err.response.data),
              icon: "error",
              confirmButtonClass: "btn btn-danger btn-fill",
              buttonsStyling: false,
            });
          });
      }
    },
    handleDelete(index, row) {

		let inventoryId = row[this.StorageID].InventoryID;
		if (inventoryId == 0) {
			swal.fire({
				title: "ไม่พบคลังสินค้าหรือสินค้า",
				text: ``,
				icon: "error",
				confirmButtonClass: "btn btn-danger btn-fill",
				buttonsStyling: false,
			});

			return 
		} else {
			console.log("InventoryID",inventoryId)
		}


      swal
        .fire({
          title: this.$t("delete_confirm"),
          text: this.$t("delete_confirm_question") + row.ProductName,
          icon: "warning",
          showCancelButton: true,
          confirmButtonClass: "btn btn-success btn-fill",
          cancelButtonClass: "btn btn-danger btn-fill",
          confirmButtonText: this.$t("confirm"),
          cancelButtonText: this.$t("cancel"),
          buttonsStyling: false,
        })
        .then((result) => {
          if (result.value) {



            this.InventoryDelete( inventoryId )
              .then((resp) => {
                this.listData();
                swal.fire({
                  title: this.$t("delete_success"),
                  text: ``,
                  icon: "success",
                  confirmButtonClass: "btn btn-success btn-fill",
                  buttonsStyling: false,
                });
              })
              .catch((err) => {
                swal.fire({
                  title: this.$t(err.response.data.Msg),
                  text: this.getErrorText(err.response.data),
                  icon: "error",
                  confirmButtonClass: "btn btn-danger btn-fill",
                  buttonsStyling: false,
                });
              });
          }
        });
    },
	GetItemBalance(row) {
		return row[this.StorageID].Balance
	},
	GetItemBalanceStamp(row) {
		return row[this.StorageID].BalanceStamp
	},
	GetItemIn(row) {
		return row[this.StorageID].ItemIn
	},
	GetItemOut(row) {
		return row[this.StorageID].ItemOut
	},
	GetItemOutByOrder(row) {
		return row[this.StorageID].ItemOutByOrder
	},
    selectionChange(selectedRows) {
      this.selectedRows = selectedRows;
    },
  },
};
</script>
<style>
.no-border-card .card-footer {
  border-top: 0;
}
</style>
